module.exports = __webpack_public_path__ + "img/access.caa0fc50.svg";